module.exports = __webpack_public_path__ + "img/ic_link_edit.1747f229.svg";